import { create } from 'zustand';
import type { GestaoView } from '../types';
import type { TaskFilters, TaskSortField, SortDirection } from '../../shared/types/task';

interface GestaoState {
  viewMode: GestaoView;
  selectedTaskId: string | null;
  drawerOpen: boolean;
  filters: TaskFilters;
  sortField: TaskSortField;
  sortDirection: SortDirection;
  page: number;
  pageSize: number;

  // Actions
  setViewMode: (mode: GestaoView) => void;
  selectTask: (taskId: string | null) => void;
  openDrawer: (taskId: string) => void;
  closeDrawer: () => void;
  setFilters: (filters: Partial<TaskFilters>) => void;
  resetFilters: () => void;
  setSortField: (field: TaskSortField) => void;
  setSortDirection: (dir: SortDirection) => void;
  setPage: (page: number) => void;
}

const DEFAULT_FILTERS: TaskFilters = {
  status: ['pending', 'in_progress'],
  priority: [],
  search: '',
  overdue: false,
};

export const useGestaoStore = create<GestaoState>((set) => ({
  viewMode: 'kanban',
  selectedTaskId: null,
  drawerOpen: false,
  filters: { ...DEFAULT_FILTERS },
  sortField: 'sla_deadline',
  sortDirection: 'asc',
  page: 1,
  pageSize: 100,

  setViewMode: (viewMode) => set({ viewMode }),

  selectTask: (selectedTaskId) => set({ selectedTaskId }),

  openDrawer: (taskId) => set({ selectedTaskId: taskId, drawerOpen: true }),

  closeDrawer: () => set({ drawerOpen: false }),

  setFilters: (partial) =>
    set((state) => ({
      filters: { ...state.filters, ...partial },
      page: 1,
    })),

  resetFilters: () => set({ filters: { ...DEFAULT_FILTERS }, page: 1 }),

  setSortField: (sortField) => set({ sortField }),

  setSortDirection: (sortDirection) => set({ sortDirection }),

  setPage: (page) => set({ page }),
}));
